import axios from "axios";
import { baseUrl } from '../config/clientsConfig'

const propertyService = {
  createProperty: (propertyData) => {
    return axios.post(`${baseUrl}/property`, propertyData);
  },
  fetchProperties: () => {
    return axios.get(`${baseUrl}/properties`);
  },
  getPropertiesName: () => {
    return axios.get(`${baseUrl}/properties-name`);
  },
  getPropertiesNameType : (type) => {
    return axios.get(`${baseUrl}/getPropertyNameByType?type=${type}`);
    },
  fetchPropertiesByType: async (type) => {
    if (type === "All Properties") {
      return await axios.get(`${baseUrl}/properties`);
    }
    return await axios.get(
      `${baseUrl}/property/getproperty/bytype?type=${type}`
    );
  },
  fetchPropertyById: async (propertyId) => {
    return await axios.get(`${baseUrl}/property/${propertyId}`);
  },

  updatePropertyById: async (propertyId, propertyData) => {
    return await axios.put(`${baseUrl}/property/${propertyId}`, propertyData);
  },
  estimateCreating  : async (body) => {
    return await axios.post(`${baseUrl}/plotEstimate`, body);
  },
  getAllEstimatesHistories : async (date)=>{
    return await axios.get(`${baseUrl}/plotEstimates?startDate=${date}`);
  }
  ,
  getEstimateById : async (id)=>{
    return await axios.get(`${baseUrl}/plotEstimate/${id}`);
  }
};
export default propertyService;
